/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationSchema } from './locationSchema';

export const pageResponseLocationSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(locationSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
